<template>
    <Modal v-model="show" title="入库单SKU打印" :closable="false" :mask-closable="false" @on-visible-change="showModal" :width="800">
        <el-form :inline="true" ref="itemForm" >
            <el-form-item label="打印模板" prop="templateUrl">
                <el-select v-model="templateUrl">
                    <el-option v-for="(vl,ky) in paperSizes" :key="ky" :label="ky" :value="vl">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-table size="small" :data="items" border style="width: 100%" small>
                  <el-table-column align="center" prop="thumb" fixed="left" label="商品名" width="150">
                    <template slot-scope="scope">
                        <el-image :src="scope.row.pic" style="width: 100px;height: auto;" fit="fit"></el-image>
                     
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="variationName" label="规格/属性" width="180">
                    <template slot-scope="scope">
                        <el-input size="small" v-model="scope.row.variationName"></el-input>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="skuCode" label="sku码" width="180">
                    <template slot-scope="scope">
                        <el-input size="small" v-model="scope.row.skuCode"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="count" label="数量" width="120">
                    <template slot-scope="scope">
                        <el-input size="small" v-model="scope.row.count"></el-input>
                    </template>
                </el-table-column>
            </el-table>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="cancel">取消</el-button>
            <el-button size="small" type="primary" :loading="modalLoading" @click="ok">确定</el-button>
        </div>
    </Modal>
</template>
<script>
import api from "@/api/api"

export default {
    name: 'StorageProduct',
    data() {
        return {
            paperSizes: {
                "50mm*30mm": api.skuTemplateUrl_50_30,
                "50mm*30mm(含条码)":api.skuTemplateUrl_50_30_code
            },
            templateUrl: api.skuTemplateUrl_50_30,
            loading: false,
            show: false,
            items: [],
            modalLoading: false


        };
    },
    mounted: function() {



    },
    props: [
        'products'
    ],
    methods: {
        hideDialog() {
            this.modalLoading = false;
            this.show = false;
        },
        showDialog() {
            this.show = true;
        },
        showModal: function(value) {
            if (value) {
                this.getDetail();
            } else {
                this.items = [];
            }
        },
        getDetail() {
            this.items = [];
            for (var i = 0; i < this.products.length; i++) {
                let vr = {
                    id:this.products[i].id,
                    skuCode: this.products[i].skuCode,
                    variationName: this.products[i].variationName,
                    count: 1,
                    pic: this.products[i].pics,
                }
                this.items.push(vr);
            }
        },
        ok: function() {
            let orderData = [];
            for (var i = 0; i < this.items.length; i++) {
                let item = this.items[i];
                if (item.count > 0) {
                    for (var j = 1; j <= item.count; j++) {
                        orderData.push({
                            "documentID": item.id + "-"  + j,
                            "contents": [{
                                data: {
                                    variationName: item.variationName,
                                    skuCode: item.skuCode
                                },
                                templateURL: this.templateUrl

                            }]
                        });
                    }
                }
            }

            this.$emit("boxCallBack", orderData);
        },
        cancel: function() {
            this.hideDialog();
            this.$emit("cancel");
        }
    }
}
</script>
<style scoped>
</style>